import React, { useState } from "react";
import { QueryRenderer, graphql } from "react-relay";
import Tree from "./Tree";
// import environment from "../Environment";
import environment from "../AuthEnv";
import { GC_USER_ID } from "../constants";
import Spinner from "../Spinner";

// import loadable from "@loadable/component";
// const Tree = loadable(() => import("./Tree"));

const userSubscriptionQuery = graphql`
    query TreeContainerSubscriptionQuery {
        viewer {
            ...Tree_user_Subscription
        }
    }
`;

function TreeContainer(props) {
    const uid = localStorage.getItem(GC_USER_ID);
    const [userId, setUserId] = useState(uid);
    let settings = props.settings;
    return (
        <QueryRenderer
            environment={environment}
            query={userSubscriptionQuery}
            variables={{ id: userId }}
            render={({ error, props }) => {
                if (error) {
                    return <div>Error!</div>;
                }
                if (!props) {
                    return (
                        <div>
                            <Spinner isLoading={true} />
                        </div>
                    );
                }
                return (
                    <div>
                        <Tree
                            settings={settings}
                            user_Subscription={props.viewer}
                        />
                    </div>
                );
            }}
        />
    );
}

export default TreeContainer;
